import protoRoot from "../proto-root";

const name = "setCameraVideoRecordingRPCRequest";

function create({ state }: { state: CameraRecordingState }) {
  const SetCameraVideoRecordingRPCRequest = protoRoot.lookupType("comm.SetCameraVideoRecordingRPCRequest");
  const RecordingStateEnum = SetCameraVideoRecordingRPCRequest.lookupEnum("RecordingState");

  const payload = SetCameraVideoRecordingRPCRequest.create({
    state: RecordingStateEnum.values[state]
  });

  return { payload, name };
}

const setCameraVideoRecordingRpcRequest = { create, name };

export default setCameraVideoRecordingRpcRequest;
